import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconMap16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="map">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5257 0.14935C15.8205 0.331557 16 0.653423 16 1V13C16 13.3788 15.786 13.725 15.4472 13.8944L11.4472 15.8944C11.21 16.013 10.9354 16.0326 10.6838 15.9487L5.07673 14.0797L1.44721 15.8944C1.13723 16.0494 0.769085 16.0329 0.474269 15.8507C0.179452 15.6684 0 15.3466 0 15V3C0 2.62123 0.214002 2.27497 0.552786 2.10557L4.55279 0.105574C4.79 -0.0130346 5.06462 -0.0325511 5.31623 0.0513177L10.9233 1.92033L14.5528 0.105574C14.8628 -0.0494204 15.2309 -0.0328564 15.5257 0.14935ZM4 2.61804L2 3.61804V13.382L4 12.382V2.61804ZM6 2.38743V12.2792L10 13.6126V3.72076L6 2.38743ZM14 12.382L12 13.382V3.61803L14 2.61803V12.382Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconMap24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="map">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.4382 23.8989C16.4426 23.8967 16.447 23.8945 16.4514 23.8923L23.4472 20.3944C23.786 20.225 24 19.8788 24 19.5V1C24 0.653425 23.8205 0.331559 23.5257 0.149352C23.2309 -0.0328545 22.8628 -0.0494185 22.5528 0.105576L15.9717 3.39611L8.40598 0.0861055C8.35288 0.0625091 8.29815 0.0437384 8.24245 0.0298237C8.1574 0.00856212 8.07044 -0.00127265 7.98385 0.000131531C7.88177 0.00177433 7.77973 0.0190372 7.68143 0.0520869C7.63614 0.0673054 7.59175 0.0858353 7.54865 0.107646L0.552786 3.60558C0.214002 3.77497 0 4.12123 0 4.5V23C0 23.3466 0.179452 23.6684 0.474269 23.8507C0.769085 24.0329 1.13723 24.0494 1.44721 23.8944L8.02829 20.6039L15.5939 23.9139C15.6202 23.9255 15.6469 23.936 15.6739 23.9453C15.9252 24.0321 16.2003 24.0149 16.4382 23.8989ZM7 18.882V2.61804L2 5.11804V21.382L7 18.882ZM9 18.846L15 21.471V5.15402L9 2.52902V18.846ZM17 5.11804V21.382L22 18.882V2.61804L17 5.11804Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconMap48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="map">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.4063 1.08624L32.4008 8.08385C32.7648 8.24309 33 8.60271 33 9V46C33 46.3375 32.8298 46.6522 32.5473 46.8369C32.2649 47.0216 31.9084 47.0514 31.5992 46.9162L16.0133 40.0973L1.42289 46.9062C1.11318 47.0507 0.751101 47.0271 0.462825 46.8435C0.174548 46.6599 0 46.3418 0 46V9C0 8.61148 0.22504 8.25812 0.577115 8.09382L15.5725 1.09598C15.6142 1.07623 15.6571 1.0595 15.7007 1.04582C15.7978 1.01537 15.8981 1.00018 15.9982 1C16.1377 0.999757 16.2769 1.02871 16.4063 1.08624ZM15 38.3631V3.5702L2 9.63687V44.4298L15 38.3631ZM17 38.346L31 44.471V9.65402L17 3.52902V38.346Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M47.5372 1.15653C47.8255 1.34012 48 1.65823 48 2V39C48 39.3885 47.775 39.7419 47.4229 39.9062L32.4229 46.9062C32.1132 47.0507 31.7511 47.0271 31.4628 46.8435C31.1745 46.6599 31 46.3418 31 46V9C31 8.61148 31.225 8.25812 31.5771 8.09382L46.5771 1.09382C46.8868 0.949288 47.2489 0.972939 47.5372 1.15653ZM33 9.63687V44.4298L46 38.3631V3.5702L33 9.63687Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
